import { RootState } from "../../../store";

export const getUserFriends = (state: RootState) => state.userFriendsReducer.friends;
